module.exports = "<p>\r\n    {{ 'Media.HashtagEditor.TBD' | translate }} \r\n</p>\r\n"